import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import "../css/jobList.css";
import { useNavigate, Link } from "react-router-dom";

const Career = () => {
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/jobs`,
        { withCredentials: true }
      );
      setJobs(res.data);
    } catch (err) {
      console.error("Error fetching jobs:", err);
    }
  };
  const handleApply = async (jobId) => {
  try {
    // store job_id in session
    await axios.post(
      `${API_BASE_URL}/api/set-session`,
      { job_id: jobId },
      { withCredentials: true }
    );

    // check if user is logged in
    const sessionRes = await axios.get(
      `${API_BASE_URL}/api/check-session`,
      { withCredentials: true }
    );

    if (sessionRes.data.loggedIn) {
      navigate("/multistep");
    } else {
      navigate("/login");
    }

  } catch (error) {
    console.error("Apply Now Error:", error);
  }
};
/* ================= FILTER DATA FROM DB ================= */

  const bannerJob = jobs.find(
    job => job.job_heading && job.job_image
  );

  const availableJobs = jobs.filter(
    job => job.pageheading
  );

  return (
    <>
      {bannerJob && (
        <div className="about-container">
          <div className="about-left">
            <div className="breadcrum">
              <div className="heading-wrapper">
                <h1 className="about-heading">
                  <strong>{bannerJob.job_heading}</strong>
                  <span className="about-heading-bg">
                    {bannerJob.job_heading}
                  </span>
                </h1>
              </div>

              <Link className="home-link" to="/">
                {bannerJob.job_home}
              </Link>
              <span className="seperator">|</span>
              <span className="aboutus-link">
                {bannerJob.job_heading}
              </span>
            </div>
          </div>

          <div className="about-right">
            <img
              src={bannerJob.job_image}
              alt="Careers banner"
              className="about-image"
            />
          </div>
        </div>
      )}

      <div className="job-list-containerone">
        <div className="job-list-container">

          {availableJobs.length > 0 && (
            <h2>{availableJobs[0].pageheading}</h2>
          )}

          {availableJobs.length === 0 ? (
            <p>No openings available right now.</p>
          ) : (
            <ul className="job-list">
              {availableJobs.map(job => (
                <li key={job.id} className="job-item">
                  <h3>{job.title}</h3>

                  <p><b>Description:</b></p>
                  <p className="job-description-text">
                    {job.description}
                  </p>

                  <p><b>Location:</b> {job.location}</p>
                  <p><b>Salary:</b> {job.salary}</p>

                  <p><b>Qualifications:</b></p>
                  <p className="job-qualifications-text">
                    {job.qualifications}
                  </p>

                  <button
                    className="applybutton"
                    onClick={() => handleApply(job.id)}
                  >
                    Apply now
                  </button>
                </li>
              ))}
            </ul>
          )}

        </div>
      </div>
    </>
  );
};

export default Career;
